import { ProgramId } from '@/core/Programs'
import client from '../../client'
import {
  CanRequestResponse,
  ListTimetablesResponse,
  CreateReservationRequestParams,
  ReservationRequestId,
  MyRequestsResponse,
} from './types'

export * from './types'

export const canRequest = async () => {
  const { data } = await client.get<CanRequestResponse>(
    '/user/reservationRequests/canRequest'
  )
  return data
}

export const listTimetables = async (
  programId: ProgramId,
  params?: { date: string }
) => {
  const { data } = await client.get<ListTimetablesResponse>(
    `/user/reservationRequests/program/${programId}/timetables`,
    { params }
  )
  return data
}

export const myRequests = async () => {
  const { data } = await client.get<MyRequestsResponse>(
    '/user/reservationRequests'
  )
  return Array.isArray(data) && data.length === 0 ? null : data
}

export const create = async (params: CreateReservationRequestParams) => {
  return await client.post('/user/reservationRequests', params)
}

export const cancel = async (reservationRequestId: ReservationRequestId) => {
  return await client.put('/user/reservationRequests/cancel', {
    reservationRequestId,
  })
}

export const confirm = async (reservationRequestId: ReservationRequestId) => {
  return await client.put('/user/reservationRequests/confirm', {
    reservationRequestId,
  })
}
